<ng-container *transloco="let t">
  <h2 tuiTitle="m">{{ title }}</h2>
  @let isExportEhrEnabled = isExportEhrEnabled$ | async;
  @let pdfPreview = patientReportDocumentService.pdfPreview$ | async;

  <pxc-patient-report-document
    class="min-h-0 flex-1"
    [clientCode]="clientCode"
    [departmentIds]="departmentIds"
    [patient]="patient">
    <div class="flex flex-col gap-2">
      @if (isExportEhrEnabled) {
        <button appearance="primary" tuiButton type="button" [disabled]="!pdfPreview.isSuccess" (click)="export()">
          {{ t('Exporter vers le DPI') }}
        </button>
      }

      <button
        tuiButton
        type="button"
        [appearance]="isExportEhrEnabled ? 'outline' : 'primary'"
        [disabled]="!pdfPreview.isSuccess"
        (click)="download(pdfPreview.data.content)">
        {{ t('Télécharger') }}
      </button>

      <button appearance="outline" tuiButton type="button" (click)="close()">
        {{ t('Annuler') }}
      </button>
    </div>
  </pxc-patient-report-document>
</ng-container>
